export const LIBRARY_INSTALL_HINT = 'From the top menu Windows -> Libraries';
